import {
  useNoProductsFound 
} from "@/hooks/Category"
import resourceUrl from "@/util/makeUrl"
import Link from "next/link"
import {
  useMemo 
} from "react"
import {
  FormattedMessage, useIntl 
} from "react-intl"

import {
  useStyle 
} from "@/classify"
import Image from "@/components/Image"
import defaultClasses from "./noProductsFound.module.css"
import noProductsFound from "./noProductsFound.png"

const NoProductsFound = (props) => {
  const {
    categoryId, isShowTips = true 
  } = props || {}
  const classes = useStyle(defaultClasses, props.classes)

  const {
    formatMessage 
  } = useIntl()
  const talonProps = useNoProductsFound({
    categoryId,
  })

  const {
    recommendedCategories 
  } = talonProps

  const categoryItems = useMemo(() => {
    return recommendedCategories.map((category) => {
      const uri = resourceUrl(`/${category.url_path}${category.url_suffix}`)

      return (
        <li key={category.id} className={classes.listItem}>
          <Link href={uri}>{category.name}</Link>
        </li>
      )
    })
  }, [classes, recommendedCategories])

  const headerText = formatMessage({
    id: "noProductsFound.noProductsFound",
    defaultMessage: "Sorry! We couldn't find any products.",
  })

  return (
    <div className={classes.root}>
      <Image
        alt={headerText}
        classes={{
          image: classes.image, root: classes.imageContainer 
        }}
        src={noProductsFound.src}
      />
      <h2 className={classes.title}>{headerText}</h2>
      <div className={classes.categories}>
        {isShowTips ? <p>
          <FormattedMessage
            id={"noProductsFound.tryOneOfTheseCategories"}
            defaultMessage={"Try one of these categories"}
          />
        </p> : null}
        <ul className={classes.list}>{categoryItems}</ul>
      </div>
    </div>
  )
}

export default NoProductsFound
